import type { EditorView } from "@tiptap/pm/view";

const SCROLL_MARGIN = 24;

export function scrollPosIntoSurface(view: EditorView, pos: number): boolean {
    const surface = view.dom.closest(".captions-editor-surface");
    if (!(surface instanceof HTMLElement)) return false;

    const coords = view.coordsAtPos(pos);
    const rect = surface.getBoundingClientRect();
    const above = rect.top + SCROLL_MARGIN - coords.top;
    const below = coords.bottom - (rect.bottom - SCROLL_MARGIN);
    if (above > 0) surface.scrollTop -= above;
    else if (below > 0) surface.scrollTop += below;
    return true;
}
